"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = Component;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const UserProfile = __importStar(require("@genesys/client-core/lib/user-profile"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const LocalElements = __importStar(require("../elements"));
const ProductProperties = __importStar(require("@genesys/shared/lib/product-properties"));
const property_1 = require("@genesys/property");
const PropertiesSelector = __importStar(require("@genesys/client-core/lib/genesys-properties-selector"));
const PropertiesSelectorHelper = __importStar(require("@genesys/client-core/lib/genesys-properties-selector-helpers"));
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
const ResultPresenter = __importStar(require("./result-presenter"));
const productQuery = (0, graphql_tag_1.default) `
  query ProductPricePreview($productInput: GetProductInputType!) {
    product {
      allCurrencies {
        id
        name
      }
      salesOrganisations {
        id
        name
      }
      product(input: $productInput) {
        id
        properties {
          id
          sortNo
          name
          quantity
          defaultValues {
            value
            propertyFilter
          }
          groupName
          validationFilter
          visibilityFilter
          quantityConversionParams
          values {
            id
            value
            validationFilter
            sortNo
            image
          }
        }
      }
    }
  }
`;
function Component(props) {
    const translation = {
        propertyName: (propertyName, translate) => translate(LanguageTexts.productProperty(props.productId, propertyName)),
        propertyValue: (propertyName, propertyValue, translate) => translate(LanguageTexts.productPropertyValue(props.productId, propertyName, propertyValue))
    };
    return (React.createElement(LocalElements.ConfigurationContainer, null,
        React.createElement(GraphQLQuery.QueryProduct, { query: productQuery, variables: {
                productInput: {
                    productId: props.productId
                }
            } }, product => {
            switch (product.type) {
                case "ErrorResultProps":
                    return React.createElement("div", null, "Unknown productId");
                case "PartialResultProps":
                case "StaleResultProps":
                    return React.createElement(Elements.Loader, null);
                case "LoadedResultProps":
                    return (React.createElement(UserProfile.UserProfile, null, userProfile => {
                        const properties = props.selectedProperties ||
                            ProductProperties.createDefaultProperties(product.data.product.product.properties.map(p => (Object.assign(Object.assign({}, p), { defaultValues: p.defaultValues.map(d => ({
                                    value: property_1.PropertyValue.fromString(d.value),
                                    propertyFilter: property_1.PropertyFilter.fromStringOrEmpty(d.propertyFilter)
                                })) }))), true);
                        const propertyDefinitions = PropertiesSelectorHelper.createPropertiesSelectorPropertiesFromGraphqlProperties(product.data.product.product.properties, properties).map(p => (Object.assign(Object.assign({}, p), { visibility_filter: property_1.PropertyFilter.Empty })));
                        const selectedCurrency = props.selectedCurrency || userProfile.currency;
                        const userDefaultSalesOrg = () => {
                            const salesOrg = UserProfile.getPrimarySalesOrganisation(userProfile.salesOrganisations, userProfile.defaultSalesOrganisation, userProfile.applicationClaims);
                            return salesOrg && salesOrg.id;
                        };
                        const selectedSalesOrg = props.selectedSalesOrg ||
                            userDefaultSalesOrg() ||
                            product.data.product.salesOrganisations[0].id;
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Elements.FlexContainerStack, { center: false, centerVertically: false },
                                React.createElement(Elements.FlexContainerRow, { center: false },
                                    React.createElement(Elements.H3, null, "Component configuration")),
                                React.createElement("div", null,
                                    React.createElement(PropertiesSelector.PropertiesSelectorContainer, { productProperties: propertyDefinitions, onChange: pvs => props.setProperties(pvs), screenAmountProfileFieldGroup: "Settings." + props.productId, selectedProperties: properties, uniqueId: "Price-preview-selector", customTranslation: translation, includeCodes: true }))),
                            React.createElement(Elements.FlexContainerRow, { center: false },
                                React.createElement(Elements.FlexContainerStack, { center: false, centerVertically: false },
                                    React.createElement(Elements.FlexContainerRow, { center: false },
                                        React.createElement(Elements.H3, null, "Sales information")),
                                    React.createElement("div", null,
                                        React.createElement(Elements.StyledTable, null,
                                            React.createElement("tbody", null,
                                                React.createElement("tr", null,
                                                    React.createElement("td", null, "Currency"),
                                                    React.createElement("td", null,
                                                        React.createElement(Elements.SelectBox, { value: selectedCurrency, onChange: e => props.setCurrency(e.target.value) }, product.data.product.allCurrencies.map(c => (React.createElement("option", { key: c.id, value: c.id },
                                                            c.name,
                                                            " (",
                                                            c.id,
                                                            ")")))))),
                                                React.createElement("tr", null,
                                                    React.createElement("td", null, "Sales org"),
                                                    React.createElement("td", null,
                                                        React.createElement(Elements.SelectBox, { value: selectedSalesOrg, onChange: e => props.setSalesOrg(e.target.value) }, product.data.product.salesOrganisations.map(so => (React.createElement("option", { key: so.id, value: so.id },
                                                            so.id,
                                                            " (",
                                                            so.name,
                                                            ")"))))))))),
                                    React.createElement(Elements.FlexContainerRow, { center: false },
                                        React.createElement(Elements.FlexContainerStack, { center: false },
                                            React.createElement(LocalElements.ActionContainer, null,
                                                React.createElement(Elements.StandardButton, { onClick: () => props.setShowResults(true) }, "Calculate")),
                                            React.createElement(LocalElements.ActionContainer, null,
                                                React.createElement(Elements.InputEditText, { value: props.variantProperties, onChange: e => props.setVariantProperties(e.target.value), placeholder: "comma separated properties" })))),
                                    props.showResults && (React.createElement(ResultPresenter.Component, { currencyCode: selectedCurrency, productId: props.productId, properties: properties, salesOrgCode: selectedSalesOrg }))))));
                    }));
                default:
                    throw new Error("Unknown type");
            }
        })));
}
//# sourceMappingURL=configuration.js.map